import { types, actions } from './requests'
export const CREATEOFFICE_TYPES = {
    ...types('CREATEOFFICE')
}
export const CREATEOFFICE_ACTIONS = {
    ...actions('CREATEOFFICE')
}
